const TotalOrder = () => {
  return (
    <div className="content-page-admin">
      <div className="title-page-admin">
        <i className="bx bx-book-alt"></i>
        <p>TotalOrder page</p>
      </div>
    </div>
  );
};

export default TotalOrder;
